const parent = document.querySelector(".pro-div-2");

const data = [
    {
        title:"Lifein1",
        img: new URL("./img/projects/lifein1.png", import.meta.url).href,
        desc:"Lifein1 is a visual reminder that time is finite. Every dot represents a single week of your life — lived, present, and yet to come. By turning time into something you can see, Lifein1 helps you reflect, refocus, and rethink how you spend the weeks you have left.",
        tools:["REACT","REACT-ROUTER","JAVASCRIPT","TAILWIND","CSS"],
        linkGithub:"https://github.com/surajmaru/Lifein1-weekstracker",
        linkLiveview:"https://lifein1.vercel.app/",
    },
    {
        title:"TimeW",
        img: new URL("./img/projects/focus.png", import.meta.url).href,
        desc:"TimeW is a minimal focus app that lives on your desktop, showing the current time, date, and motivational quotes to keep you locked in. Set a focus duration, hit the focus button, and let TimeW help you stay present, productive, and distraction-free.",
        tools:["JAVASCRIPT","REACT","VITE","CSS","TAILWIND"],
        linkGithub:"https://github.com/surajmaru/TimeW-Focus-app",
        linkLiveview:"https://timew.vercel.app/",
    },
    {
        title:"ASMR Typing",
        img: new URL("./img/projects/asmr-typing.png", import.meta.url).href,
        desc:"A cool and Aesthetic site where you can relax and test your typing skill with the soothing background music and vibe.",
        tools:["JAVASCRIPT","REACT","VITE","CSS","TAILWIND"],
        linkGithub:"https://github.com/surajmaru/Aesthetic-Typing-ASMR",
        linkLiveview:"https://asmr-typing.vercel.app/",
    },
    {
        title:"Reaction Time Checker",
        img: new URL("./img/projects/reaction-time.png", import.meta.url).href,
        desc:"A React app to check how fast your reaction is",
        tools:["JAVASCRIPT","REACT","VITE","TAILWIND"],
        linkGithub:"https://github.com/surajmaru/reaction-time-react-game",
        linkLiveview:"https://reaction-time-react-game.vercel.app/",
    },
    {
        title:"Youtube Video/Audio Downloader",
        img: new URL("./img/projects/yt-downloader.png", import.meta.url).href,
        desc:"A modern YouTube Video & Audio Downloader built with React and powered by yt-dlp, allowing users to download videos or extract high-quality audio with a fast, intuitive interface.",
        tools:["JAVASCRIPT","EXPRESS","NODE.JS","YT-DLP","FFMPEG"],
        linkGithub:"https://github.com/surajmaru/Youtube-Video-Audio-Downloader",
        linkLiveview:"",
    },
    {
        title:"Forkify Web App",
        img: new URL("./img/projects/forkify.png", import.meta.url).href,
        desc:"A JavaScript-powered recipe application featuring API-based search, bookmarking, and dynamic serving calculations.",
        tools:["HTML","SASS","JAVASCRIPT","API","PARCEL"],
        linkGithub:"https://github.com/surajmaru/forkify-app",
        linkLiveview:"https://forkify-suraj.vercel.app/",
    },
    {
        title:"Game Marketplace App",
        img:new URL("./img/projects/gamestore.png", import.meta.url).href,
        desc:"A modern Game Marketplace built with JavaScript, focused on performance, interactivity, and clean user experience.",
        tools:["HTML","SASS","JAVASCRIPT","PARCEL"],
        linkGithub:"https://github.com/surajmaru/Game-Marketplace",
        linkLiveview:"https://suraj-gamestore.vercel.app/",
    },
    {
        title:"Mapty",
        img: new URL("./img/projects/mapty.png", import.meta.url).href,
        desc:"A workout tracker that uses geolocation and maps to log, display, and manage running and cycling activities.",
        tools:["HTML","CSS","JAVASCRIPT","GEOLOCATION","LEAFLET"],
        linkGithub:"https://github.com/surajmaru/Mapty-App-JS",
        linkLiveview:"https://mapty-app-suraj.vercel.app/",
    },
    {
        title:"Bankist App",
        img: new URL("./img/projects/bankist-app.png", import.meta.url).href,
        desc:"A banking app that demonstrates account management, transfers, loans, and real-time balance updates.",
        tools:["HTML","CSS","JAVASCRIPT","LOCALSTORAGE","TIMEOUTS"],
        linkGithub:"https://github.com/surajmaru/Bankist-App-JS",
        linkLiveview:"https://bankist-app-suraj.vercel.app/",
    },
    {
        title:"Bankist Web",
        img: new URL("./img/projects/bankist-dom.png", import.meta.url).href,
        desc:"A DOM-focused banking interface that demonstrates dynamic UI updates, event handling, and smooth user interactions using JavaScript.",
        tools:["HTML","CSS","JAVASCRIPT","BOUNDINGCLIENT"],
        linkGithub:"https://github.com/surajmaru/Bankist-Website-JS",
        linkLiveview:"https://bankist-website-suraj.vercel.app/",
    },

]

 export function render(){

    data.forEach(data => {
        const html = `

<div class="reveal">
      <div class="pro-2 pro-1-1 web ">
        <p class="pro-title">${data.title}</p>
        <img draggable="false" class="pro-img" loading="lazy" decoding="async" src="${data.img}" >
        <p class="pro-desc">${data.desc}</p>

        <div class="pro-bottom">

          <div class="pro-items">
          ${data.tools.map(tool => 
              `<p class="pro-item reveal2">${tool}</p>`
            ).join("")}
          </div>
          
          <div class="footer-divider"></div>
          
          <div class="pro-footer reveal2">
            <a href="${data.linkGithub}" target="_blank">
              <div class="pro-footer1">
                <p >GITHUB</p> 
                <img class="pro-footer-github" src=${new URL("./img/github.svg", import.meta.url).href}>
              </div>
            </a>
            ${data.linkLiveview ? 
              `<a href="${data.linkLiveview}" target="_blank">
              <div class="pro-footer1">
                <p >LIVE VIEW</p> 
                <img class="pro-footer-github" src=${new URL("./img/link.svg", import.meta.url).href}>
              </div>
            </a>` : ""}
          </div>
        </div>
      </div>
      </div>

`;

parent.insertAdjacentHTML("beforeend",html);
    });

}